import React from "react";
import { Card } from "react-bootstrap";
import plusIcon from "../../assets/images/plusIcon.png";
import expLevel from "../../assets/images/Icon.png";
import expLevel2 from "../../assets/images/Icon2.png";
import rightArrow from "../../assets/images/rightArrow.png";
import upArrow from "../../assets/images/upArrow.png";
//import "./Projects.scss";
import groupImage from "../../assets/images/groupImage.png";
import "./ImageCard.scss";


export default function ImageCard(props) {
    return (
      <div className="imageCard">

<div className="row illastrationContainer">
          
<div className="col-md-4 col-lg-4 col-sm-12">
  <img className="imgStyle" src={props.imageCardData.image} />
  
</div>
<div className="col-md-8 col-lg-8 col-sm-12">
 
  <div className="row">
    <div className="col-md-8">
   
    <div className="illastration-box">
        <div
          className="ellipse"
          
        ></div>
        <div >
          {" "}
          {/* High Risk */}
          {props.imageCardData.status}
        </div>
      </div>
        <div className="illastrationDesc">
          {" "}
          {/* Supply chain disruptions */}
          {props.imageCardData.heading}
        </div>
     
      <div className="illastrationSubDesc">
      {props.imageCardData.subHeading}
      {/* Supply chains will be disrupted based on ongoing geopolitical crisis, Covid, and inflationary pressures. */}
      </div>
      
   
   
 

  <div className="row riskLevelConatiner">
    <div className="col-lg-4 col-md-4 col-sm-12">
      <div className="riskLevel">RELEVANCE</div>
      <div className="residual_percentage">
        {props.imageCardData.relevance}%{" "}
        <div className="expLevel_Img">
        <div className="icon-arrow-up"></div> {props.imageCardData.relevancePercentage} %{" "}
        </div>
      </div>
    </div>
    <div className="verticalLine col-lg-1 col-md-1"></div>
    <div className="col-lg-3 col-md-3 col-sm-12">
      <div className="RESIDUAL_risk"> INDICATORS</div>
      <div className="residual_percentage">
      {props.imageCardData.indicator1}%{" "}
        <div className="expLevel2_img">
        <div className="icon-arrow-up"></div>{props.imageCardData.indicatorPercentage1}%{" "}
        </div>
      </div>
    </div>
    <div className="verticalLine col-lg-1 col-md-1"></div>
    <div className="col-lg-3 col-md-3 col-sm-12">
      <div className="indicators">INDICATORS</div>
      <div className="indicators_title"> 
      {props.imageCardData.indicator2}
        <div className="expLevel_indicator">
        <div className="icon-arrow-down"></div> {props.imageCardData.indicatorPercentage2}%{" "}
        </div>
      </div>
    </div>
  </div>
    </div>
    <div className="col-md-4">
<div className="readStyle" > <button className="button-style">Read article</button>
</div> <div className="watch-list">
 <img className="image-watch" src={plusIcon}/>
 <div>Watch List</div>
 </div>
    </div>
  </div>
 
</div>
</div>
</div>)}
